import React from 'react';
import { cn } from '../../lib/cn';

const Button = React.forwardRef(function Button(
  {
    as: Component = 'button',
    variant = 'primary',
    size = 'md',
    icon,
    isLoading = false,
    disabled,
    className,
    children,
    ...props
  },
  ref
) {
  const sizeClass =
    size === 'icon'
      ? 'ds-button--icon'
      : size === 'sm'
        ? 'ds-button--sm'
        : size === 'lg'
          ? 'ds-button--lg'
          : null;

  const classes = cn('ds-button', `ds-button--${variant}`, sizeClass, isLoading && 'is-loading', className);

  return (
    <Component
      ref={ref}
      className={classes}
      disabled={disabled || isLoading}
      {...props}
    >
      {icon ? <span className="ds-button__icon">{icon}</span> : null}
      {children}
    </Component>
  );
});

export { Button };
